import * as React from "react";
import { Routes, Route } from "react-router-dom";
import { CreateSubjectScreen } from "./CreateSubjectScreen";
import { EditSubjectScreen } from "./EditSubjectScreen";
import { ViewSubjectScreen } from "./ViewSubjectScreen";
import { PrivateRoute } from "../Core/PrivateRoute";
import { PermissionEnum } from "../misc/api/ApiPermissionEnum";
import { SubjectsListScreen } from "./List/SubjectsListScreen";

export const SubjectsScreen = () => {
    return (
        <Routes>
            <Route
                index
                element={
                    <PrivateRoute permissions={[
                        PermissionEnum.ViewSubjects,
                        PermissionEnum.ViewSiteSubjects,
                        PermissionEnum.CreateSubject,
                        PermissionEnum.EditSubject
                    ]}>
                        <SubjectsListScreen />
                    </PrivateRoute>
                }
            />
            <Route path="Create"
                element={
                    <PrivateRoute permissions={[
                        PermissionEnum.CreateSubject,
                        PermissionEnum.CreateSiteSubjects
                    ]}>
                        <CreateSubjectScreen />
                    </PrivateRoute>
                }
            />
            <Route path="Edit/:id"
                element={
                    <PrivateRoute permissions={[
                        PermissionEnum.EditSubject,
                        PermissionEnum.EditSiteSubjects
                    ]}>
                        <EditSubjectScreen />
                    </PrivateRoute>
                }
            />
            <Route path="View/:id" element={
                <PrivateRoute permissions={[
                    PermissionEnum.ViewSubjects, PermissionEnum.ViewSiteSubjects
                ]}>
                    <ViewSubjectScreen />
                </PrivateRoute>
            }
            />
        </Routes>
    );
}
